<script setup lang="ts"></script>

<template>
  <div>
    <div class="uk-flex uk-flex-between uk-background-secondary">
      <span class="uk-text-middle uk-text-center uk-padding-small header-text">
        <span uk-icon="icon: warning" class="uk-padding-small"></span>
        <span>Welcome to the private beta testing of the OpenVetting - Opened on 12/01/23</span>
      </span>
    </div>
    <hr />
    <div class="uk-card uk-card-default uk-card-body">
      <h2 class="uk-margin-top">
        <span>We are on a mission to help foster better discussions.</span>
        <br />
        Help us by providing feedback on how we can improve.
      </h2>

      <h4 class="uk-margin-bottom">
        <img src="/icons/black/icon-black-arrow.svg" width="48" class="uk-margin-small-right" />
        Contact us at:
        <a href="mailto:SupportTeam@objectively.ai" data-cy="support-email"
          ><i>SupportTeam@objectively.ai</i></a
        >
      </h4>
    </div>
  </div>
</template>

<style lang="scss">
.header-text {
  color: white;
}
</style>
